<template>
    <div class="alarm__dashboard">
        <div class="alarm__dashboard--title">
            <p>{{ $t('alarm.alarm') }}</p>
        </div>
        <TradingViewTicker />

        <div class="alarm__dashboard--content">
            <!-- <div class="category__btns">
                <SubButton v-for="btn in topButtons" :key="btn.key" :icon="btn.icon" :label="btn.label" :class="btn.key"
                    :description="btn.description" @click="setTab(btn.key)" />
            </div> -->

            <div class="premium__btns">
                <MainButton v-for="btn in mainButtons" :key="btn.key" :icon="btn.icon" :title-primary="btn.primary"
                    :title-secondary="btn.secondary" :subtitle="btn.subtitle" @click="setTab(btn.key)"
                    :bg="btn.bg"  :style="{ '--btn-color': btn.color }" />
            </div>

            <div class="category__btns">
                <SubButton v-for="btn in subButtons" :key="btn.key" :icon="btn.icon" :label="btn.label" :class="btn.key"
                    :description="btn.description" @click="setTab(btn.key)" />
            </div>

            <!-- <img class="banner" :src="bannerImage" alt="banner" /> -->

            <div class="banner" @click="openGuide">
                <div>
                    <div class="banner__title">{{ $t('alarm.img.title') }}</div>
                    <div class="banner__subtitle">{{ $t('alarm.img.content1') }}<br>{{ $t('alarm.img.content2') }}</div>
                </div>
                <div class="banner__btn">
                    <div>{{ $t('alarm.img.btn') }}</div>
                </div>
            </div>
            <AlarmModal v-if="openModal" @close="openModal = ''" :type="openModal"/>
        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { chkPermission } from '@/utils/permission.js'
import MainButton from '@/components/alarm/sub/MainButton.vue'
import SubButton from '@/components/alarm/sub/SubButton.vue'
import AlarmModal from '@/components/alarm/common/AlarmModal.vue'
import TradingViewTicker from '@/components//trading/TradingViewTicker.vue';

import scoreIcon from '@/assets/images/dark/score_btn.png'
import supportIcon from '@/assets/images/dark/sr_btn.png'
import priceIcon from '@/assets/images/dark/price_btn.png'

import smartBg from '@/assets/images/alarm/smart_bg.png'
import smartIcon from '@/assets/images/alarm/smart_icon.svg'
import premiumBg from '@/assets/images/alarm/premium_bg.png'
import premiumIcon from '@/assets/images/alarm/premium_icon.svg'
import nextBg from '@/assets/images/alarm/next_bg.png'
import nextIcon from '@/assets/images/alarm/next_icon.svg'
import lightBg from '@/assets/images/alarm/light_bg.png'
import lightIcon from '@/assets/images/alarm/light_icon.svg'
import rocketIcon from '@/assets/images/alarm/rocket_icon.png'


const { t } = useI18n()
const router = useRouter()
const userPackage = ref(localStorage.getItem("userPackage"));
const openModal = ref('');
const result = ref(null);

const checkingPermission = ref(true); // 체크 완료인지 확인
const permission = ref(false); // 권한 확인
const okNext = ref(false); // next 차트 권한 여부 
const okSmart = ref(false); // 10000 이상 패키지 결제 여부 
const isPayment = ref(0); // 결제여부
const alarmPayment = ref(0); // 알람 결제 여부 > endDate 가 없거나 만료된 경우 false / 이외 true
const isLight = ref(false); // light 차트 권한 여부 260830 까지는 3000 + 알람구매 / 이후는 10000 달러이상 구매시
const promotionPeriod = ref(true); // light 차트 프로모션 날짜 / 날짜 지남 여부에 따른 modal 안내창 
const okLight = ref(false); //


onMounted(async () => {
  try {
    result.value = await chkPermission();
    permission.value = result.value.permission;
    okNext.value = result.value.okNext;
    okSmart.value = result.value.okSmart;
    isPayment.value = result.value.isPayment;
    userPackage.value = result.value.userPackage;
    alarmPayment.value = result.value.alarmPayment;
    isLight.value = result.value.isLight;
    okLight.value = result.value.okLight;
    promotionPeriod.value = result.value.isLightPromotionPeriod;
  } finally {
    checkingPermission.value = false;
  }
});

// const topButtons = [
//     {
//         key: 'real',
//         icon: scoreIcon,
//         label: t('real.title'),
//         description: t('alarm.dashboard.real'),
//     },
// ]

const mainButtons = [
    {
        key: 'smart',
        icon: smartIcon,
        bg: smartBg,
        primary: t('alarm.subTab.smart'),
        secondary: t('alarm.menu.signal'),
        color: '#58F09C',
        subtitle: { primary: t('alarm.dashboard.smart') }
    },
    {
        key: 'premium',
        icon: premiumIcon,
        bg: premiumBg,
        primary: t('alarm.subTab.premium'),
        secondary: t('alarm.menu.signal'),
        color: '#DDBD0B',
        subtitle: { primary: t('alarm.dashboard.pre') }
    },
    {
        key: 'next',
        icon: nextIcon,
        bg: nextBg,
        primary: t('alarm.next.next'),
        secondary: t('alarm.menu.signal'),
        color: '#4DCAED',
        subtitle: { primary: t('alarm.dashboard.next') }
    },
    {
        key: 'light',
        icon: lightIcon,
        bg: lightBg,
        primary: t('light.title'),
        secondary: t('alarm.menu.signal'),
        color: '#D85EF0',
        subtitle: { primary: t('alarm.menu.light')}
    },
]

const subButtons = [
    {
        key: 'rocket',
        icon: rocketIcon,
        label: t('rocket.title'),
        description: t('rocket.subTitle'),
    },
    {
        key: 'score',
        icon: scoreIcon,
        label: t('alarm.score.score'),
        description: t('alarm.dashboard.score'),
    },
    {
        key: 'support',
        icon: supportIcon,
        label: t('alarm.dashboard.sr'),
        description: t('alarm.dashboard.sr'),
    },
    {
        key: 'price',
        icon: priceIcon,
        label: t('header.priceAlarm'),
        description: t('alarm.dashboard.market'),
    }
]

const matchTab = {
    price: '/alarm/price',
    premium: '/alarm/premium?type=premium',
    score: '/alarm/score?type=score',
    smart: '/alarm/smart?type=smart',
    support: '/alarm/support-resistance',
    next: '/alarm/next?type=next',
    light: '/alarm/light?type=light',
    rocket: '/alarm/rocket?type=rocket',
}

const headerList = {
    price: t('alarm.menu.price'),
    score: t('alarm.menu.score'),
    support: t('alarm.menu.sr'),
    smart: t('alarm.menu.smart'),
    premium: t('alarm.menu.premium'),
    next: t('alarm.menu.next'),
    light: t('alarm.menu.light'),
    rocket: t('alarm.menu.rocket'),
}

const headerTitle = ref('')

function setTab(tabKey) {
    if (checkingPermission.value) return;

    else if (tabKey == 'smart' && !okSmart.value) {   
        openModal.value = 'smart';
    }

    else if (tabKey == 'light' && !okLight.value) {   
        promotionPeriod.value ?
            openModal.value = 'isPayment' : openModal.value = 'light';
    }

    else if (tabKey == 'next' && !okNext.value) {   
        openModal.value = 'next';
    }
    
    else if (Number(userPackage.value) <= 3000 && !alarmPayment.value) {
        openModal.value = 'isPayment';
    }

    else if (!permission.value) {
        if (!isPayment.value) {
            openModal.value = 'isPayment';
        }
        else {
            openModal.value = tabKey;
        }
    }

    else {
        headerTitle.value = headerList[tabKey] || ''
        router.push(matchTab[tabKey])
    }
}

// 가이드 영상으로 이동 함수
function openGuide() {
    // router.push('/alarm/guide-video')
    // window.open(`/guide/guide_${locale.value}.pdf`, '_blank');
    // PDF 가이드 화면으로 이동
  router.push('/alarm/guide-pdf');
}

</script>

<style scoped>
.alarm__dashboard {
    background: #11150F;
    min-height: 100%;
}

.alarm__dashboard--title {
    color: var(--Grayscale-Gray10, #F9FBFD);

    font-family: "Lexend", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 16px;
    font-weight: 600;
    line-height: 125% ;
    letter-spacing: -0.16px;
}

.alarm__dashboard--title p {
    padding: 14px 20px;
}

.alarm__dashboard--content {
    padding: 24px 20px;
    background: var(--Grayscale-Gray100);
}

.premium__btns {
    display: grid;
    grid-template-columns: repeat(4, 1fr); 
    gap: 8px; 
    margin-bottom: 24px;
}
.category__btns {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.banner {
    position: relative;
    display: flex;
    width: 100%;
    height: fit-content;
    margin: 24px auto;
    padding: 20px 23px;
    background-image: url(../../assets/images/alarm/banner.png);
    background-size: cover;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.banner div {
    text-align: start;
}

.banner__btn {
    display: flex;
    padding: 6px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 4px;
    background: var(--Primary-Main100, #FF7A00);

    color: var(--Grayscale-Gray10, #F9FBFD);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
}

.banner__btn img {
    width: 20px;
    height: 20px;
    margin-left: 0.2rem;
}

.banner__title {
    color: var(--Grayscale-White, #FFF);
    text-align: center;
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -1px;
}

.banner__subtitle {
    color: var(--Grayscale-Gray50, #6F7784);
    font-family: "Poppins", sans-serif, "Sawarabi Gothic", sans-serif, "LXGW WenKai TC", cursive;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

@media (max-width: 1000px) {
    .premium__btns {
        grid-template-columns: repeat(2, 1fr); 
    }
}


@media (max-width: 400px) {
    .banner__title {
        font-size: 20px;
    }

    .banner__subtitle {
        font-size: 12px;
    }

    .banner {
        flex-direction: column;
        align-items: start;
    }
}
</style>
